<template>
  <div class="map">
    <Tools @handlerClear="handlerClear" />
    <OlBaseMap ref="mapData" :tagertId="tagertId" :showTool="false"></OlBaseMap>
    <div v-if="showFlag">
      <div
        id="bottom_property"
        style="display: block"
        :style="{ height: hidebottom ? '33px' : '280px' }"
      >
        <div class="spliter"></div>
        <div class="container">
          <div class="header">
            <div class="icon"></div>
            <div class="title">查询结果:{{ titles }}</div>
            <div
              v-show="isClose"
              class="arrow"
              :class="hidebottom ? 't2b' : 'b2t'"
              @click="bottomhideClick()"
            ></div>
            <div v-show="isClose" class="close" @click="close()"></div>
          </div>
          <div class="content_table">
            <Spin class="demo-spin-col" v-show="spinshow">
              <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
              <div>Loading</div>
            </Spin>
            <Table
              height="210"
              size="small"
              border
              :columns="columns"
              :data="tableData"
              @on-row-dblclick="ondbrowclick"
              class="selectTB"
            ></Table>
            <Page :total="total" show-total class="pagecss" show-elevator @on-change="changepage" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OlBaseMap from '@/components/mapbase/OlBaseMap.vue';
import BottomProperty from '@/view/Bottomshow/BottomProperty.vue'; //底部框架
import Tools from './Tools.vue';
import customConfig from 'customConfig';
export default {
  components: { OlBaseMap, BottomProperty, Tools },
  data() {
    return {
      tagertId: 'basemap',
      showFlag: false,
      columns: [{ title: '序号', type: 'index', fixed: 'left', align: 'center' }],
      tableData: [],
      total: 0,
      spinshow: false,
      titles: '',
      hidebottom: false,
      isClose: true,
      features: [],
      polygonsLonLats: [],
      featureArrList: [],
    };
  },
  methods: {
    // 工具条清除 重置方法
    handlerClear() {
      this.$emit('handlerClear');
    },
    // 一进来就进行定位
    async handleSetZoom(layerInfo) {
      var extentList = [];
      var _this = this;
      let res = await this.publicMethod.getlayerXML(layerInfo.url);
      if (res) {
        $(res)
          .find('Layer')
          .find('Layer')
          .each(function() {
            var item = $(this);
            if (item.find('Name').text() == layerInfo.layername.split(':')[1]) {
              extentList.push(
                Number(item.find('BoundingBox').attr('minx')),
                Number(item.find('BoundingBox').attr('miny')),
                Number(item.find('BoundingBox').attr('maxx')),
                Number(item.find('BoundingBox').attr('maxy'))
              );

              _this.olmap.getView().fit(extentList);
            }
          });
      }
    },
    /**
     * @description: 只有点击分析才执行这个方法进行定位
     * @Author: zjx
     * @Date: 2023-03-21 14:41:03
     * @param {*} XY
     * @return {*}
     */
    autoFitLayer(XY) {
      let point = XY[0][0];
      var view = this.olmap.getView();
      view.setCenter(point);
      view.setZoom(15);
    },
    /**
     * @description: 关闭属性列表事件
     * @Author: zjx
     * @Date: 2023-03-21 14:41:19
     * @return {*}
     */
    close() {
      this.showFlag = false;
      this.columns = [];
      this.tableData = [];
    },
    // 双击列表进行定位 并且设置样式
    ondbrowclick(data, index) {
      var that = this;
      var extent = this.featureArrList[index].getGeometry().getExtent(); //获取一个坐标数组的边界，格式为[minx,miny,maxx,maxy]
      var center = ol.extent.getCenter(extent); //获取边界区域的中心位置
      this.olmap.getView().setCenter(center); //设置当前地图的显示中心位置
      this.olmap.zxQueryLayer.getSource().forEachFeature(function(fea) {
        fea.setStyle(
          new ol.style.Style({
            stroke: new ol.style.Stroke({
              color: 'rgba(0, 0, 255, 0.8)',
              width: 2,
            }),
            fill: new ol.style.Fill({
              color: 'rgba(255, 255, 255, 0.2)', //填充颜色
            }),
          })
        );
      });

      var cnv = document.createElement('canvas');
      var ctx = cnv.getContext('2d');
      var img = new Image();
      img.src = '../static/img/fill.png';
      img.onload = function() {
        var pattern = ctx.createPattern(img, 'repeat');
        that.featureArrList[index].setStyle(
          new ol.style.Style({
            stroke: new ol.style.Stroke({
              color: 'rgba(255, 0, 0, 1)',
              width: 3,
            }),
            fill: new ol.style.Fill({
              color: pattern,
            }),
          })
        );
      };
    },
    // 切换页
    changepage(v) {
      this.$bus.emit('CultivatedLandTablePageNumber', { index: v, type: 'change' });
    },
    /**
     * @description: 点击列表的收缩按钮事件
     * @Author: zjx
     * @Date: 2023-03-21 14:40:00
     * @param {*} if
     * @return {*}
     */
    bottomhideClick() {
      // 收缩
      if (this.hidebottom) {
        this.hidebottom = false; //展开
      } else {
        this.hidebottom = true; //收起
      }
    },
    // 清除图层事件
    clearLayer() {
      var layers = this.olmap.getLayers();
      let arr = [];
      layers.forEach(item => {
        if (item && item.getProperties().id && item.getProperties().id == '_layertree_:Tyson') {
          arr.push(item);
        }
      });
      for (let i = 0; i < arr.length; i++) {
        this.olmap.removeLayer(arr[i]);
      }
    },
    // 点击左侧列表的查看按钮 触发事件
    handleCultivatedLand(params) {
      let { data: val, type } = params;
      // 获取自定义配置
      const { layerInfo } = customConfig.themeService[this.$route.query.customId];
      let layers = this.processMapLayers(val.resultData.features);
      // 处理表格数据和表头
      this.processTableData(val.resultData.features, layerInfo, val.resultData.totalFeatures);
      if (type === 'analyse') {
        this.autoFitLayer(layers);
      } else {
        this.handleSetZoom(layerInfo);
      }

      // 显示数据
      this.showFlag = true;
      this.hidebottom = false; //展开
    },

    // // 点击分析进行处理的事件
    // handleCultivatedMap(val) {
    //   // 处理地图图层数据
    //   const layers = this.processMapLayers(val.resultData.features);

    //   // 自适应地图视图
    //   this.autoFitLayer(layers);

    //   // 创建地图图层
    //   this.createLayer(layers);
    // },
    // 处理表格数据和表头
    processTableData(features, layerInfo, numbers) {
      var featureArr = [];
      features.forEach((item, index) => {
        var geojson_format = new ol.format.GeoJSON();
        let featureObj = geojson_format.readFeature(item.geometry);
        featureObj.values_ = Object.assign(featureObj.values_, item.properties);
        featureArr.push(featureObj);
      });
      var source = this.olmap.zxQueryLayer.getSource();
      source.clear();
      source.addFeatures(featureArr);
      this.featureArrList = featureArr;
      if (features.length === 0) {
        return this.close();
      }
      // 如果有表头别名就替换
      this.columns = Object.keys(features[0].properties).map((item, index) => {
        if (layerInfo && layerInfo.hasOwnProperty('field')) {
          for (const key in layerInfo.field) {
            if (item === key) {
              item = layerInfo.field[key];
              break;
            }
          }
        }
        return {
          title: item,
          key: layerInfo.hasOwnProperty('field')
            ? Object.keys(features[0].properties)[index]
            : item,
          align: 'center',
          width: 120,
        };
      });
      // 如果有表数据别名就替换
      const { keyFilds } = layerInfo.wfs;
      const { tableValue } = layerInfo;
      const fieldValueMap = new Map(
        (tableValue && Array.isArray(tableValue.fieldValue)
          ? tableValue.fieldValue
          : []
        ).map(ele => [`${ele.key}`, ele.name])
      );
      this.tableData = features.map(item => {
        const newItem = { ...item.properties };
        if (newItem.hasOwnProperty(keyFilds)) {
          const value = newItem[keyFilds];
          if (fieldValueMap.has(value)) {
            newItem[keyFilds] = fieldValueMap.get(value);
          }
        }
        return newItem;
      });
      this.titles = this.tableData[0].DLMC;
      this.total = numbers;
    },
    // 处理地图图层数据
    processMapLayers(features) {
      const layers = [];
      features.forEach(item => {
        item.geometry.coordinates[0].forEach(i => {
          layers.push(i);
        });
      });
      this.polygonsLonLats = layers;
      return layers;
    },
  },
  mounted() {
    this.$bus.off('CultivatedMap');
    this.$bus.on('CultivatedMap', data => {
      let { data: val, type } = data;
      this.clearLayer();
      const { layerInfo } = customConfig.themeService[this.$route.query.customId];
      if (type !== 'clear') {
        this.olmap.addLayer(val.MappjsonResult);
        if (val.mapData.hasOwnProperty('sldName') && val.mapData.sldName) {
          let param = val.MappjsonResult.getSource().getParams(); //先获取图层的样式
          param.STYLES = val.mapData.sldName;
          val.MappjsonResult.getSource().updateParams(param); //设置图层的样式
        }
        this.handleSetZoom(layerInfo);
      }
    });

    this.$bus.off('CultivatedLand');
    this.$bus.on('CultivatedLand', this.handleCultivatedLand);
  },
};
</script>

<style lang="less" scoped>
.map {
  width: 100%;
}

.demo-spin-container {
  display: inline-block;
  width: 200px;
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}

/deep/ .bi {
  margin-left: 20px;
  height: 30px;
  border-radius: 5px;
}

/deep/ .selectTB {
  height: 210px;
}

.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}

@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }

  50% {
    transform: rotate(180deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.demo-spin-col {
  height: 237px;
  position: absolute;
  border: 1px solid #eee;
  bottom: 0px;
  z-index: 999;
  width: 100%;
  background: white;
}

/deep/ .content_table .ivu-table-cell {
  text-align: center;
  padding: 0 !important;
}

/deep/ .pagecss {
  float: right;
  margin-left: 10px;
}

.b1 {
  height: 25px;
  margin-left: 20px;
  line-height: 25px;
  margin-top: 5px;
}

#bottom_property {
  position: absolute;
  bottom: 0;
  width: 100%;
  // left: 60px;
  right: 0;
  height: 207px;
  z-index: 1001;
  // border-top: 1px solid #ccc;
  display: none;
  overflow: hidden;
}

#bottom_property .spliter {
  position: absolute;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #ddd;
}

#bottom_property .container {
  position: absolute;
  top: 2px;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  width: 100%;
}

#bottom_property .header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 30px;
  line-height: 30px;
  background-color: #0099fa;
  border-bottom: 1px solid #dddddd;
  color: white;
}

#bottom_property .header > .icon {
  height: 16px;
  width: 16px;
  position: relative;
  overflow: hidden;
  left: 5px;
  top: 7px;
  background-image: url(../../../static/img/ResourceView.png);
}

#bottom_property .header > div {
  float: left;
  font-size: 12px;
  margin-left: 7px;
}

#bottom_property .header > .b2t {
  background-image: url(../../../static/img/l1.png);
  background-position: -155px -12px;
}

#bottom_property .header > .t2b {
  background-image: url(../../../static/img/l1.png);
  background-position: -112px -12px;
}

#bottom_property .header > .close {
  background-position: -400px -6px;
  background-image: url(../../../static/img/l1.png);
  height: 16px;
  width: 16px;
  float: right;
  margin: 7px 5px 5px 0px;
  cursor: pointer;
}

#bottom_property .content_table {
  position: absolute;
  top: 30px;
  left: 0;
  right: 0;
  bottom: 0;
}

#bottom_property .header > .arrow {
  cursor: pointer;
  margin: 7px 5px 5px 0px;
  height: 16px;
  width: 16px;
  float: right;
}

.modeltitle {
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
}

.modeltitle i {
  border-radius: 2px;
  background: #3d92dc;
  width: 4px;
  height: 30px;
  float: left;
  margin: 0px 5px 0 20px;
}

.sqlstyle /deep/ .ivu-form-item-content {
  margin-left: 0px !important;
}

.sqlstyle /deep/ .ivu-form-item-content textarea {
  height: 90px !important;
}

.filtersty li {
  margin-right: 5px;
  display: inline-block;
  margin-top: 5px;
}

.filterfieldsty {
  height: 120px;
  overflow-y: auto;
  border: 1px solid #ccc;
  width: 100%;
  padding: 5px;
  margin-top: 5px;
}

.filterfieldsty li {
  height: 25px;
  line-height: 25px;
  border-bottom: 1px solid #ccc;
}

/deep/ .modelcontent .ivu-table td,
.modelcontent .ivu-table th {
  height: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/CultivatedLandComponent/Map.vue